// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file NavaidFile.proto (package NavaidFile, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file NavaidFile.proto.
 */
export const file_NavaidFile: GenFile = /*@__PURE__*/
  fileDesc("ChBOYXZhaWRGaWxlLnByb3RvEgpOYXZhaWRGaWxlIoYCCgpOYXZhaWRGaWxlEhAKCGZpbGVEYXRhGAEgASgMEi4KCGZpbGVUeXBlGAIgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEicKAmlkGAMgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSLQoIbmF2YWlkSWQYBCABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRIuCglwcm9qZWN0SWQYBSABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRIuCghmaWxlTmFtZRgGIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZUJACi1jb20uZ212LmRlbWV0ZXIubmF2YWlkcy5tb2RlbC5wcm90by5nZW5lcmF0ZWRCD05hdmFpZEZpbGVQcm90b2IGcHJvdG8z", [file_google_protobuf_wrappers]);

/**
 * @generated from message NavaidFile.NavaidFile
 */
export type NavaidFile = Message<"NavaidFile.NavaidFile"> & {
  /**
   * @generated from field: bytes fileData = 1;
   */
  fileData: Uint8Array;

  /**
   * @generated from field: google.protobuf.StringValue fileType = 2;
   */
  fileType?: string;

  /**
   * @generated from field: google.protobuf.Int32Value id = 3;
   */
  id?: number;

  /**
   * @generated from field: google.protobuf.Int32Value navaidId = 4;
   */
  navaidId?: number;

  /**
   * @generated from field: google.protobuf.Int32Value projectId = 5;
   */
  projectId?: number;

  /**
   * @generated from field: google.protobuf.StringValue fileName = 6;
   */
  fileName?: string;
};

/**
 * Describes the message NavaidFile.NavaidFile.
 * Use `create(NavaidFileSchema)` to create a new message.
 */
export const NavaidFileSchema: GenMessage<NavaidFile> = /*@__PURE__*/
  messageDesc(file_NavaidFile, 0);

